import React, { RefObject, useContext, useMemo } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import styled from "styled-components";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";

import { isSubtitleText } from "components/stories/video-studio/sidebar/tabs/subtitle/utils";
import { IMAGE_TYPE, VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import DeleteOption from "./DeleteOption";
import DuplicateOption from "./DuplicateOption";
import ReplaceOption from "./ReplaceOption";

const ContextMenuContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 2px;
  font-size: 14px;
  position: fixed;
  width: 150px;
  z-index: 9999;
`;

interface ElementContextOptionsProps {
  contextMenuPosition: { x: number; y: number };
  contextMenuVisible: boolean;
  contextMenuRef: RefObject<HTMLDivElement>;
  currentElement: ElementState;
  onSetContextMenuVisible: (value: boolean) => void;
  preview: Preview;
}

const ElementContextOptions: React.FC<ElementContextOptionsProps> = ({
  contextMenuPosition,
  contextMenuVisible,
  contextMenuRef,
  currentElement,
  preview,
  onSetContextMenuVisible
}) => {
  const { data: { activeElementsId } } = useContext(CreatomateContext);

  const isASubtitleSelected = useMemo(() => (
    activeElementsId.some(id => {
      const creatomateElements = preview.getElements();
      const elementToTest = creatomateElements?.find(element => element.source.id === id);
      return isSubtitleText(elementToTest?.source?.name);
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [activeElementsId]);

  if (!contextMenuVisible) return <></>;

  return (
    <div className="RightClick-container">
      <ContextMenuContainer
        style={isASubtitleSelected ? {
          top: contextMenuPosition.y - 40, left: contextMenuPosition.x }
          : { top: contextMenuPosition.y - 75, left: contextMenuPosition.x }}
        ref={contextMenuRef}
      >
        {(currentElement?.source?.type === VIDEO_TYPE
        || currentElement?.source?.type === IMAGE_TYPE) && (
          <ReplaceOption
            currentElement={currentElement}
            onSetContextMenuVisible={onSetContextMenuVisible}
            preview={preview}
          />
        )}
        {!isASubtitleSelected && (
          <DuplicateOption
            currentElement={currentElement}
            onSetContextMenuVisible={onSetContextMenuVisible}
            preview={preview}
          />
        )}
        <DeleteOption
          currentElement={currentElement}
          onSetContextMenuVisible={onSetContextMenuVisible}
          preview={preview}
        />
      </ContextMenuContainer>
    </div>
  );
};

export default ElementContextOptions;
